import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { useNavigation } from '@react-navigation/native'
import { H6 } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { LoggedInStackParamList } from '@zet/utils/interface'

import { SpotlightCardType } from '../../../types'

type TrainingSpotlightCardProps = {
  item?: SpotlightCardType
}

const TrainingSpotlightCard = ({ item }: TrainingSpotlightCardProps) => {
  const navigation = useNavigation<LoggedInStackParamList>()

  const handleNavigation = () => {
    navigation.navigate('TraingVideoPlayer', {
      title: item?.title,
      youtube_video_details: item?.ytVideoDetails,
    })
  }

  return (
    <Pressable
      className="ml-3 mr-2 w-[224] rounded"
      onPress={handleNavigation}
      eventName="click_action"
      eventPayload={{
        item_name: 'RecordedTraining',
        training_name: item?.title,
      }}
    >
      <Image
        source={{ uri: item?.thumbnail?.url }}
        resizeMode="contain"
        style={styles.imageStyle}
        className="rounded"
      />
      <H6 className="mt-3 leading-5 text-white">{item?.title}</H6>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  imageStyle: {
    width: 224,
    height: 126,
    backgroundColor: 'rgba(57, 31, 6, 0.40)',
  },
})

export default TrainingSpotlightCard
